import { str_trim } from "../inc/helpers";

export default class Navigation {
  constructor(data_flyout_menu) {    
    this.nav = document.querySelector(".js-site-header");
    this.nav_voices = this.nav?.querySelectorAll(".js-nav-voice");
    
    this.nav_mobile = document.querySelector(".js-site-nav-mobile");
    this.nav_voices_mobile = this.nav_mobile?.querySelectorAll(".js-nav-voice");
    this.nav_mobile_visible = false;

    this.flyout_menu = document.querySelector(".js-flyout-menu");
    this.flyout_col_sx, this.flyout_col_dx, this.flyout_siblings;
    this.flyout_visible = false;
    this.data_flyout_menu = this.flatten_data_flyout_menu(data_flyout_menu);

    this.btn_toggle_menu = this.nav?.querySelector(".js-btn-toggle-menu");
    this.btn_back = this.nav?.querySelector(".js-btn-nav-back");

    this.transition = null;      
    this.timing = 250;
        
    // console.log(data_flyout_menu, this.data_flyout_menu);
  }

  init() {
    if (!this.flyout_menu)
      return;
    
    this.flyout_siblings = Array.from(this.flyout_menu.parentNode.children)?.filter(el => el !== this.flyout_menu);
    
    this.flyout_menu.addEventListener("click", this.hide_flyout_menu.bind(this));
    this.flyout_menu.querySelector(".js-btn-close")?.addEventListener("click", this.hide_flyout_menu.bind(this));
    this.btn_back?.addEventListener("click", this.hide_flyout_menu.bind(this));
    this.flyout_menu.querySelector(".flyout-menu-content")?.addEventListener("click", (e) => e.stopPropagation());
    document.addEventListener("keydown", (e) => {
      if (
        e.key === "Escape"
        && (this.flyout_col_sx && this.flyout_col_dx)
      ) {
        this.hide_flyout_menu();
      }
    });

    this.init_nav_mobile();
    this.btn_toggle_menu?.addEventListener("click", this.toggle_nav_mobile.bind(this));             
  
    this.init_nav();
  }

  init_nav_mobile() {    
    this.nav_voices_mobile?.forEach(
      (voice) => voice.addEventListener(
        "click", 
        () => this.handle_voice_click(voice.dataset.key)
      )
    );
  }

  toggle_nav_mobile() {    
    this.nav_mobile_visible = !this.nav_mobile_visible;
    
    if (this.nav_mobile_visible) {
      this.btn_toggle_menu.classList.add("is-active");
      this.nav_mobile.classList.add("is-active");
      !document.querySelector("html").classList.contains("no-overflow")
        && document.querySelector("html").classList.add("no-overflow");
    
    } else {
      this.btn_toggle_menu.classList.remove("is-active");
      this.nav_mobile.classList.remove("is-active");
      this.hide_flyout_menu();
    }
  }

  init_nav() {
    this.nav_voices?.forEach(
      (voice) => voice.addEventListener(
        "click", 
        () => this.handle_voice_click(voice.dataset.key)
      )
    );
  }  

  handle_voice_click(key) {
    const data_current = this.data_flyout_menu?.find(el => el.key === key);

    if (!data_current) 
      return;

    this.render_flyout_menu(data_current);
  }

  render_flyout_menu(data_current) {
    this.flyout_col_sx = this.flyout_menu.querySelector(".js-flyout-col.col-sx");
    this.flyout_col_dx = this.flyout_menu.querySelector(".js-flyout-col.col-dx");

    if (!(this.flyout_col_sx && this.flyout_col_dx))
      return;

    this.flyout_col_sx.innerHTML = "";
    this.flyout_col_dx.innerHTML = "";

    const title = data_current["title"];
    const items = data_current["items"];

    this.render_title(title);
    
    items?.forEach((item) => {
      switch (item.type) {
        case "img":
          this.render_img(item.data?.img);
          break;
        case "links_group":
          this.render_links_group(item.data);
          break;
        case "cta_card":
          this.render_cta_card(item.data);
          break;
        case "relationship_cards":
          this.render_relationship_cards(item.data?.cards);
          break;
      }
    });    

    this.show_flyout_menu();
  }
  
  show_flyout_menu() {
    !this.flyout_menu.classList.contains("is-visible")
      && this.flyout_menu.classList.add("is-visible");
    this.flyout_menu.removeAttribute("inert");
    this.flyout_siblings?.forEach(s => 
      s === this.nav
        ? s.removeAttribute("inert")
        : s.setAttribute("inert", "")
    );
    
    this.flyout_visible = true;
    this.btn_back?.classList.add("is-active");
    !document.querySelector("html").classList.contains("no-overflow")
      && document.querySelector("html").classList.add("no-overflow");
  }

  hide_flyout_menu() {
    this.flyout_menu.classList.remove("is-visible");
    this.flyout_menu.setAttribute("inert", "");
    this.flyout_siblings?.forEach(s => s.removeAttribute("inert"));
    this.flyout_visible = false;
    this.btn_back?.classList.remove("is-active");
    document.querySelector("html").classList.remove("no-overflow");

    clearTimeout(this.transition);
    if (this.flyout_col_sx && this.flyout_col_dx) {
      this.transition = setTimeout(() => {
        this.flyout_col_sx.innerHTML = "";
        this.flyout_col_dx.innerHTML = "";
      }, this.timing);    
    }
  }

  render_title(data) {
    const title = document.querySelector("#template-flyout-title")?.cloneNode();

    if (!(data && title))
      return;

    title.removeAttribute("id");
    title.textContent = data;

    this.flyout_col_dx.appendChild(title);    
  }

  render_img(data) {
    if (!data) 
      return;

    const url = data.url;
    const img = document.querySelector("#template-flyout-img")?.cloneNode();
    
    if (!(url && img)) 
      return;

    img.removeAttribute("id");
    img.src = url;
    this.flyout_col_sx.appendChild(img);
  }

  render_links_group(data) {
    if (!data)
      return;

    const links = data["links"];
    const title = data["title"];
    const list = document.querySelector("#template-flyout-list")?.cloneNode(true);
    
    if (!(links && list))
      return;

    list.removeAttribute("id");

    const list_title = list.querySelector(".flyout-list-title");
    const list_voices = list.querySelector(".flyout-list-voices");

    if (title && list_title) {
      list_title.textContent = title;
    }

    links.forEach((link) => {
      const li = document.createElement("li");
      const a = link["is_button"] 
        ? document.querySelector("#template-flyout-btn")?.cloneNode(true) 
        : document.createElement("a");          
      
      if (!a) return;

      a.removeAttribute("id");

      a.href = link.link.url;
      a.target = link.link.target ? link.link.target : "_self";
      
      if (link["is_button"]) {
        a.querySelector("span").textContent = link.link.title;

      } else {
        a.textContent = link.link.title;
      }
      
      li.appendChild(a);
      list_voices?.appendChild(li);
    });

    this.flyout_col_dx.appendChild(list);
  }

  render_cta_card(data) {
    const card = document.querySelector("#template-flyout-card")?.cloneNode(true);
    
    if (!(data && card))
      return;

    card.removeAttribute("id");
    
    const card_desc = card.querySelector(".card-text");
    const card_img = card.querySelector("figure img");
    const card_btn = card.querySelector(".btn-primary");
    
    const desc = data["desc"];
    const img_url = data["img"]["url"];
    const link = data["link"];
    
    if (card_desc && desc) {
      card_desc.innerHTML = desc;
    }

    if (card_img && img_url) {
      card_img.src = img_url;
    }

    if (card_btn && link) {
      card_btn.href = link["url"];
      card_btn.target = link["target"] 
        ? link["target"]
        : "_self";
      card_btn.querySelector("span").textContent = link["title"];
    }

    this.flyout_col_sx.appendChild(card);
  }

  render_relationship_cards(data) {
    const container = document.querySelector("#template-flyout-cards")?.cloneNode();    
    
    if (!(data && container))
      return;

    container.removeAttribute("id");
    
    data.forEach((entry) => {
      const card = document.querySelector("#template-flyout-card")?.cloneNode(true);
      const card_img = card?.querySelector("img");
      const card_text = card?.querySelector(".card-text");
      const card_btn = card?.querySelector(".btn-primary");      
      
      if (!(card_img && card_text && card_btn))
        return;      
      
      card?.removeAttribute("id");

      card_img.src = entry?.img?.url;
      card_text.innerHTML = entry?.description;
      card_btn.href = entry?.link?.url;
      card_btn.target = entry?.link?.target 
        ? entry.link.target
        : "_self";        
      card_btn.querySelector("span").textContent = entry?.link?.title;

      container.appendChild(card);
    });

    this.flyout_col_dx.appendChild(container);
  }

  get nav_h() {
    return this.nav?.offsetHeight;
  }

  flatten_data_flyout_menu(data_flyout_menu) {
    return data_flyout_menu?.filter(
      el => el.data.items.length > 0
    )?.map(el => {
      if (el.type === "menu_voices_group") {          
        return el.data.items?.map(entry => {
          return {
            key: str_trim(entry.link.title),
            title: entry.link.title,
            items: entry.items
          }
        });
      }
      return {
        key: str_trim(el.data.link.title),
        title: el.data.link.title,
        items: el.data.items
      }
    })?.flat();
  }
}